import { Button, Col } from 'antd';
import { startIPSProject, startFMPProject } from '../../api';
import { confirmAlert } from 'react-confirm-alert'; // 
import React from 'react'
import SearchStationPendingTab from '../../containers/common/SearchStationPendingTab';

import '../../containers/startproj/DataTrackTabs/CommonComponent/confirmDialog.css'

// FUNCTION FOR PENDING TABS 
const redirect = (project, history, context) => {
  

  directToProject(project,history,'datatracker_progress',context)
};

const redirectFMP = (project, history, context) => {
  

  directToFMPProject(project,history,'fmptracker_progress',context)
};


const handleStartDataTracker = async (projectInfo, onClose ,redirectInfo) => {
  //TODO refactor this so it will know which module we are using
   const {history,context} = redirectInfo
  let startIPSProjectResponse = await startIPSProject(projectInfo);

  if (startIPSProjectResponse.status === 'WARNING') {

    confirmAlert({
      closeOnClickOutside: false,
      closeOnEscape: true,
      customUI: ({ onClose }) => {
        return (
          <div
            // className='react-confirm-alert-body'
            
            closeButton
            style={{ fontSize: 16, display: 'block', background:'#fff' }}
          >
            <div  className='pending-duplicate-header'>Record Already Exist </div> <br />
            <section className='p-2'>
              <div>
                A Record already exists with this BPID.Please go to
                <Button
                  // id={'inDevCardEditLink'}
                  type={'link'}
                  style={{
                    height: 'auto',
                    padding: '0px',
                    fontSize: 'large',
                    fontWeight: 'bold',
                  }}
                  onClick={() => {
                    redirect(startIPSProjectResponse?.data ,history,context);
                    onClose();
                  }}
                >
                  {startIPSProjectResponse?.data.stationName}
                </Button>{' '}
                project to view
              </div>
            </section>
            <div className="footer-centered-content">
              <button
                className='btn btn-primary start-5'
                onClick={() => {
                  onClose();
                }}
              >
                Ok
              </button>
            </div>
          </div>



        );
      },
    });
    return
  } else if (startIPSProjectResponse.status === 'SUCCESS') {
    onClose();
    redirect(startIPSProjectResponse.data,history,context);
  }

  // setSelectedStationName('');
};

const handleStartFMPTracker = async (projectInfo, onClose ,redirectInfo) => {
  const {history,context} = redirectInfo
  let startFMPProjectResponse = await startFMPProject(projectInfo);

  if (startFMPProjectResponse.status === 'WARNING') {

    confirmAlert({
      closeOnClickOutside: false,
      closeOnEscape: true,
      customUI: ({ onClose }) => {
        return (
          <div
            // className='react-confirm-alert-body'
            
            closeButton
            style={{ fontSize: 16, display: 'block', background:'#fff' }}
          >
            <div  className='pending-duplicate-header'>Record Already Exist </div> <br />
            <section className='p-2'>
              <div>
                A Record already exists with this BPID.Please go to
                <Button
                  // id={'inDevCardEditLink'}
                  type={'link'}
                  style={{
                    height: 'auto',
                    padding: '0px',
                    fontSize: 'large',
                    fontWeight: 'bold',
                  }}
                  onClick={() => {
                    redirectFMP(startFMPProjectResponse?.data ,history,context);
                    onClose();
                  }}
                >
                  {startFMPProjectResponse?.data.stationName}
                </Button>{' '}
                project to view
              </div>
            </section>
            <div className="footer-centered-content">
              <button
                className='btn btn-primary start-5'
                onClick={() => {
                  onClose();
                }}
              >
                Ok
              </button>
            </div>
          </div>



        );
      },
    });
    return
  } else if (startFMPProjectResponse.status === 'SUCCESS') {
    onClose();
    redirectFMP(startFMPProjectResponse.data,history,context);
  }

  // setSelectedStationName('');
};

function startProjectPendingProject(project ,ipsStations,handleStartDataTracker ,redirectInfo) {
  confirmAlert({
    closeOnClickOutside: false,
    closeOnEscape: true,
    customUI: ({ onClose }) => {
      return (
        
        <div className='react-confirm-alert-body'>
          <h2>Start Data Tracker Confirmation </h2> <br />
          <p> Are you sure you want to start the Data Tracker ? </p> <br />
          <section>
            <div className='pending-ConfirmDialog-header'>
              Please select the IPS Station Name If it's different from{' '}
              <span className='station-name-bold'>
                {' '}
                {project.stationName}.
              </span>
            </div>
            {/* <br /> */}
            {/* {project.workOrder && (
              <div className='pending-ConfirmDialog-header'>
                Work Order From Ecosys{' '}
                <span className='station-name-bold'>
                  {' '}
                  {project.workOrder}
                </span>
              </div>
            )} */}

            <Col className='p-3'>
              <SearchStationPendingTab
                stations={ipsStations}
                // handleChange={setSelectedStationName}
                onSubmit={handleStartDataTracker}
                redirectInfo={redirectInfo}
                onClose={onClose}
                project={project}
              />
            </Col>
          </section>
        </div>
      );
    },
  });
}


function startProjectPendingFMPProject(project ,ipsStations,handleStartFMPTracker ,redirectInfo) {
  confirmAlert({
    closeOnClickOutside: false,
    closeOnEscape: true,
    customUI: ({ onClose }) => {
      return (
        
        <div className='react-confirm-alert-body'>
          <h2>Start FMP Tracker Confirmation </h2> <br />
          <p> Are you sure you want to start the FMP Tracker ? </p> <br />
          <section>
            <div className='pending-ConfirmDialog-header'>
              Please select the IPS Station Name If it's different from{' '}
              <span className='station-name-bold'>
                {' '}
                {project.stationName}.
              </span>
            </div>
            {/* <br /> */}
            {/* {project.workOrder && (
              <div className='pending-ConfirmDialog-header'>
                Work Order From Ecosys{' '}
                <span className='station-name-bold'>
                  {' '}
                  {project.workOrder}
                </span>
              </div>
            )} */}

            <Col className='p-3'>
              <SearchStationPendingTab
                stations={ipsStations}
                // handleChange={setSelectedStationName}
                onSubmit={handleStartFMPTracker}
                redirectInfo={redirectInfo}
                onClose={onClose}
                project={project}
              />
            </Col>
          </section>
        </div>
      );
    },
  });
}


/////////////////////////////////
//
const directToProject = (project, history, tabName, context) => {
  let encodedStationName = encodeURIComponent(project.stationName)
  
  history.push(`/${tabName}/${encodedStationName}/${project.bpid}/${project.workOrder}/details`);
  context.setProjectTab(tabName);  
}

const directToFMPProject = (project, history, tabName, context) => {
  let encodedStationName = encodeURIComponent(project.stationName)
  
  history.push(`/${tabName}/${encodedStationName}/${project.bpid}/${project.workOrder}/details`);
  context.setProjectTab(tabName);  
}




export {redirect ,handleStartDataTracker ,handleStartFMPTracker,startProjectPendingProject,startProjectPendingFMPProject,directToProject}